import "core-js/modules/es6.array.find-index";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'FcOrgSelect',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Object || null,
      required: true
    },
    tabList: {
      type: Array,
      default: function _default() {
        return ['dep'];
      }
    },
    title: {
      type: String,
      default: '组织机构'
    },
    buttonType: {
      type: String,
      default: 'input'
    },
    // or input
    searchable: {
      type: Boolean,
      default: true
    },
    maxNum: {
      type: Number,
      default: 99
    },
    tagConfig: {
      type: Object,
      default: function _default() {
        return {
          type: 'info',
          closable: true,
          'disable-transitions': false,
          hit: false,
          color: undefined,
          size: 'small',
          effect: 'light'
        };
      }
    }
  },
  data: function data() {
    return {
      tabKeys: [],
      show: false,
      innerValue: null,
      selectedData: []
    };
  },
  computed: {
    selectedLabels: function selectedLabels() {
      return this.selectedData.map(function (t) {
        return t.label;
      }).join(',');
    }
  },
  watch: {
    value: {
      handler: function handler(val) {
        if (!val) return;
        this.reloadCmpData();
      },
      immediate: true,
      deep: true
    },
    tabList: {
      handler: function handler(val) {
        var _this = this;
        this.tabKeys = [];
        val.forEach(function (t) {
          return _this.tabKeys.push(typeof t === 'string' ? t : t.key);
        });
        this.reloadCmpData();
      },
      immediate: true
    }
  },
  methods: {
    reloadCmpData: function reloadCmpData() {
      var _this2 = this;
      this.innerValue = {};
      this.tabKeys.forEach(function (key) {
        _this2.innerValue[key] = _this2.value && _this2.value[key] ? _this2.value[key] : [];
      });
      // transfer 可能还未加载成功
      this.$nextTick(function (_) {
        _this2.initSelectedData();
      });
    },
    initSelectedData: function initSelectedData() {
      var _this3 = this;
      this.selectedData = this.tabKeys.reduce(function (res, key) {
        return res.concat(_this3.innerValue[key].map(function (t) {
          return {
            tabKey: key,
            key: _this3.getKey(t, key),
            label: _this3.getLabel(t, key)
          };
        }));
      }, []);
    },
    getPropByKey: function getPropByKey(data, tabKey, key) {
      var transfer = this.$refs['transfer'];
      if (transfer) {
        return transfer.getNodeProp(data, key, tabKey);
      } else {
        return '';
      }
    },
    getKey: function getKey(data, tabKey) {
      return this.getPropByKey(data, tabKey, 'nodeId');
    },
    getLabel: function getLabel(data, tabKey) {
      return this.getPropByKey(data, tabKey, 'label');
    },
    onClose: function onClose(item) {
      var _this4 = this;
      var list = this.innerValue[item.tabKey];
      var index = list.findIndex(function (t) {
        return _this4.getKey(t, item.tabKey) === item.key;
      });
      index > -1 && list.splice(index, 1);
      this.initSelectedData();
      this.$emit('change', this.innerValue);
    },
    onConfirm: function onConfirm(data) {
      this.innerValue = data;
      this.initSelectedData();
      this.$emit('change', this.innerValue);
    }
  }
};